import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Stack from 'react-bootstrap/Stack';
import { FaRegFilePdf } from 'react-icons/fa';
import { useAuth } from '../../providers/auth-provider';
import LoadingSpinner from '../../components/common/loading-spinner';
import { generatePdfReport } from '../../components/reports/shared/pdf-generation';
import LeaderReports from './leader-reports';
import CandidateReports from './candidate-reports';
import { retrieveAssessmentCutoffs } from '../../components/reports/shared/assessment-verbiage';
import { getUserMetricsByReference, getUserMetricsByToken } from '../../api/dashboards-api';
import { getFeedbackReportId } from '../../api/feedback-report';

function ReportsContainer({ reportSelection }) {
  const auth = useAuth();
  const { reference, token, nonce } = useParams();
  const [candidate, setCandidate] = useState({});
  const [initialized, setInitialized] = useState(false);
  const [creatingPdf, setCreatingPdf] = useState(false);

  const renderTooltip = <Tooltip id="button-tooltip">Save as PDF</Tooltip>;

  const createPdf = useCallback(async () => {
    setCreatingPdf(true);
    await generatePdfReport(`${candidate.name}.pdf`);
    setCreatingPdf(false);
  }, [candidate]);

  useEffect(() => {
    if (candidate && candidate.userId) {
      retrieveAssessmentCutoffs(auth, candidate).then(() => {
        setInitialized(true);
        if (auth.isDevelop()) {
          // Start the feedback report process
          getFeedbackReportId(auth, candidate, true).then((feedbackReportId) => {
            console.log(`Feedback report: ${feedbackReportId}`);
          });
        }
      });
    }
  }, [candidate, auth]);

  useEffect(() => {
    if (token) {
      getUserMetricsByToken(auth, nonce).then((serverCandidate) => {
        setCandidate(serverCandidate);
      });
    } else {
      getUserMetricsByReference(auth, reference).then((serverCandidate) => {
        setCandidate(serverCandidate);
      });
    }
  }, []);

  return (
    <>
      {creatingPdf && <LoadingSpinner />}
      {initialized && (
        <Stack className="w-100 candidate-profile-content report-content">
          {!creatingPdf ? (
            <div className="position-absolute pt-2 ps-2 h-100">
              <OverlayTrigger placement="right" overlay={renderTooltip}>
                <Button className="bg-transparent border-0" onClick={createPdf}>
                  <FaRegFilePdf size="2em" color="#e2000c" />
                </Button>
              </OverlayTrigger>
            </div>
          ) : (
            <div
              className="w-100 z-index-2 bg-info data-html2canvas-ignore position-fixed text-center d-table"
              style={{ height: '100px' }}
            >
              <div className="text-bold text-larger align-middle d-table-cell">Creating PDF...</div>
            </div>
          )}
          <LeaderReports reportSelection={reportSelection} candidate={candidate} creatingPdf={creatingPdf} />
          <CandidateReports reportSelection={reportSelection} candidate={candidate} creatingPdf={creatingPdf} />
        </Stack>
      )}
    </>
  );
}

export default ReportsContainer;
